// Address Management ticket classification values (PRD 4.2.5)
export const ADDRESS_SOURCES = ['Deployment file', 'Service Update', 'Address table', 'Monday MDU', 'PST', 'Other'];
export const ADDRESS_ACTIONS = ['Information', 'Creation', 'Modification'];
export const ADDRESS_STATUSES = ['No order planned', 'Order expected', 'Order ongoing', 'Delivered address'];
export const ADDRESS_SCOPES = ['One', 'Several'];
//# sourceMappingURL=address-classifications.js.map